module.exports = __webpack_public_path__ + "c5b30bb88c202396692fc3aae4f86c4f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/warning-icon@2x.png
// module id = 2872
// module chunks = 0